import { useDialogsStore } from '@/store/dialogs/dialogs'
import { DIALOGS } from '@/store/dialogs/dialogs.constants'

import { NewProductDialog } from '@/types/api/api-v4/product'

export const useProductModal = () => {
  const { showDialog, closeDialog } = useDialogsStore()

  const productDialog = ref<NewProductDialog>({
    currentProduct: null,
    productList: [],
    visible: false,
  })

  const openDialogProduct = (productDialogData: NewProductDialog) => {
    productDialog.value = productDialogData
    showDialog(DIALOGS.PRODUCT)
  }

  const closeDialogProduct = () => {
    productDialog.value = {
      currentProduct: null,
      productList: [],
      visible: false,
    }

    closeDialog(DIALOGS.PRODUCT)
  }

  return {
    productDialog,
    openDialogProduct,
    closeDialogProduct,
  }
}
